import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  searchText: {
    marginRight: theme.spacing(2),
  },
}));

export default useStyles;
